import { validateFileExt } from '@/utils/validate'
import { SongList } from '@/models/Complaint'
import complaintService from '@/api/complaint'
import CustomCollapse from '@/components/CustomCollapse'
import AutoParser from '../AutoParser'
import BatchUploadDialog from '../BatchUploadDialog.vue'
import { VerifyUploader } from '@/components'
import {
  rightFileExtType,
  LEVEL_ONE_APPEAL,
  mediaTypeMap,
  appealPlatMap,
} from '../const'

export default {
  name: 'BasicAddTable',
  components: {
    BatchUploadDialog,
    VerifyUploader,
    CustomCollapse,
    AutoParser
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    disabled: Boolean,
    loading: Boolean,
  },
  data() {
    return {
      LEVEL_ONE_APPEAL,
      mediaTypeMap,
      appealPlatMap,
      rightFileExtType,

      showBatchUpload: false,
      showEdit: false,
      form: null,
      collapseText: ['填写更多信息', '收起更多信息']
    }
  },
  computed: {
    /**
     * 表单校验项
     * @returns{Object}
     */
    rules() {
      const baseRules = {
        trackName: [{ required: true, message: '请输入作品名称', trigger: 'blur' }],
        singerName: [{ required: true, message: '请输入歌手名称', trigger: 'blur' }],
        originTrackName: [{ required: true, message: '请输入作品名称', trigger: 'blur' }],
        originSingerName: [{ required: true, message: '请输入歌手名称', trigger: 'blur' }],
        appealPlat: [{ required: true, message: '请选择侵权平台', trigger: 'change' }],
        appealUrl: [{ required: true, message: '请输入侵权链接', trigger: 'blur' }],
      }
      const rightFileRule = {
        rightFileList: [{ required: true, type: 'array', message: '请上传权利文件', trigger: 'change' }],
      }

      return { ...baseRules, ...rightFileRule }
    }
  },
  methods: {
    handleRightFileRemove(file, fileList) {
      this.form.rightFileList = fileList
    },
    handleRightFileError(err, file, fileList) {
      this.form.rightFileList = fileList
      this.$message.error('授权文件上传失败: ' + err.message)
    },
    handleRightFileSuccess(resp, file, fileList) {
      file.fileUrl = file.url = resp.data.url
      file.filePath = file.path = resp.data.file_id
      file.fileName = file.name
      file.md5 = resp.data.md5

      // 处理后台数据
      this.form.rightFileList = fileList.slice(-1)
      this.form.rightFile = {
        fileName: file.name,
        fileUrl: file.url,
        md5: file.md5
      }
    },
    handleRightFileBeforeUpload(file) {
      if (!validateFileExt(rightFileExtType, file.name)) {
        this.$message.warning('不支持的文件类型')
        return Promise.reject()
      }

      const sameFile = this.form.rightFileList.find(v => v.md5 === file.md5)
      if (sameFile) {
        this.$message.warning(`文件已存在，请检查【${file.name}】和【${sameFile.name}】`)
        return Promise.reject()
      }

      return Promise.resolve()
    },
    handleShowBatchUpload() {
      this.showBatchUpload = true
    },
    /**
     * 由具体的组件各自实现
     * @param {*} fileList
     * @param {*} rightFileList
     */
    handleUpload(fileList, rightFileList) {},
    handleAdd() {
      this.form = new SongList()
      this.form.create = true
      this.showEdit = true
    },
    handleShowEdit(row) {
      this.form = new SongList(row)
      if (this.form.rightFile) {
        this.form.rightFileList = [{
          ...this.form.rightFile,
          name: this.form.rightFile.fileName,
          url: this.form.rightFile.fileUrl
        }]
      }
      this.showEdit = true
    },
    handleClose() {
      this.showEdit = false
      this.form = null
    },
    async handleSubmit() {
      try {
        await this.$refs.form.validate()
      } catch (error) {
        return
      }
      this.$emit('save', this.form)
      this.handleClose()
    },
    handleDel(row) {
      this.$alert(`确认删除歌单（ID: ${row.tracklistId}）`, '提示', {
        type: 'warning'
      }).then(_ => {
        row.isDel = 1
        this.$emit('save', row)
        this.handleClose()
      }).catch(_ => {})
    },

    // 处理智能链接
    async handleAutoParse(url) {
      const loadIns = this.$loading({
        target: '.complaint-search-dialog',
        text: '解析中...',
      })

      try {
        const data = await complaintService.getAnalysisLinkMsg({ url })
        if (!data) {
          loadIns.close()
          return this.$alert('未找到对应作品，请您手动填写', '温馨提示', { type: 'info' })
        }

        Object.assign(this.form, {
          meidaType: 0,
          appealTrackId: data.trackId,
          trackName: data.trackName,
          singerName: data.singerName,
          srcVersion: data.trackSrcVersion,
          albumName: data.albumName,
          appealPlat: +data.platform,
          appealUrl: url
        })
        this.$emit('parsed', data)
        if (this.$refs.collapseRef) {
          this.$refs.collapseRef.open()
        }
      } catch (error) {
        this.$alert(error.message, '错误', {
          error,
          type: 'error'
        })
      }

      loadIns.close()
    }
  }
}
